const articles = { // these keys are support.healthunlocked.com slugs for specific helpscout articles
  '11-community-guidelines': '5cf62b5a04286333a26421db',
  '17-how-do-i-report-content': '5cf639472c7d3a38371311a9',
  '21-why-was-replying-turned-off': '5cf641d82c7d3a3837131217',
  '36-turn-off-replying-on-posts': '5cf64a992c7d3a38371312b5',
  '39-what-does-following-a-community-mean': '5cf64f702c7d3a38371312f7',
  '55-what-happens-when-i-remove-a-post': '5cfe76ae04286333a2646149',
  '71-why-am-i-being-asked-to-sign-in-every-time-i-access-healthunlocked': '5cfe7f292c7d3a38371353ef',
  '101-your-profile-on-healthunlocked': '5d4c52882c7d3a036965cdbd',
  '102-sentiment-feedback': '5d5c02392c7d3a7920be4421',
  '107-what-happens-when-i-report': '5dc5463b04286364bc9181e2',
  '109-why-my-youtube-video-is-not-playing': '5e6270082c7d3a7e9ae8cb6e',
  '118-explore-recommendations': '5e6b99db2c7d3a7e9ae92565',
  '120-sentiment-filter': '5e79ce5404286364bc9722d0',
  '139-different-types-of-search-on-healthunlocked': '5f6881bec9e77c001603aff2',
  '142-images-hidden-by-default': '5f87485e4cedfd0017dd1c4b',
  '143-options-when-replying-to-posts': '5f87490bc9e77c0016217d60',
  '145-community-guidelines-highlights': '5ff32598b5efec03af3ef9c2',
  '147-terms': '60241fa9a4cefb30ae5c9902',
  '148-privacy': '602422356867724dfc6f1d7c',
  '149-terms-for-affiliates': '6024252dac2f834ec538791f',
  '150-cookies': '602428a8a4cefb30ae5c9950',
  '151-security': '60245eb4ac2f834ec5387b3c',
  '154-opportunities-by-email': '602bb51a8502d1120e907d8c',
  '153-updates-to-privacy-policy-and-term-of-use': '602a86408502d1120e9077d8',
  '158-different-types-of-badges-on-healthunlocked': '602f9574b3ebfb109b584028',
  '172-what-are-archived-communities': '60a3aee427c86942e8069006',
  '173-what-are-hidden-accounts': '60b65c79c1410a601d9aefa9',
  '174-why-are-you-asking-about-my-ethinicity': '60c084e54173c622df929e4d',
  '175-why-are-you-asking-about-my-country-and-state-region': '60c86719b48f6d2c7543575b',
};

export default articles;

export type articleType = keyof typeof articles;
